module.exports = __webpack_public_path__ + "static/salon-pasajeros---asientos-4eb1cee4eae7f13ef0094220802a9528.jpg";